export const PERIOD_MONTHLY = 'monthly';
export const PERIOD_YEARLY = 'yearly';
